import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import "./LoginPage.css";

// Static credentials
const STATIC_EMAIL = "admin@simplyfi.co.in";
const STATIC_PASSWORD = "Svirtz@1234";

const LoginPage = () => {
  const navigate = useNavigate();
  
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  // Redirect if already authenticated with temp token
  useEffect(() => {
    const tempAuthToken = localStorage.getItem("tempAuthToken");
    if (tempAuthToken) {
      navigate("/home", { replace: true });
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Validate static credentials
      if (formData.email !== STATIC_EMAIL || formData.password !== STATIC_PASSWORD) {
        message.error("Invalid username or password");
        setIsLoading(false);
        return;
      }

      // Create a mock token with user data
      // In a real scenario, you would get this from the API
      const mockTokenPayload = {
        sub: STATIC_EMAIL,
        email: STATIC_EMAIL,
        userId: "1",
        roles: ["User"],
      };

      // Store temporary authentication token (separate from main authToken)
      // This is for testing purposes only and won't interfere with main login logic
      localStorage.setItem("tempAuthToken", "temp_auth_token_" + Date.now());

      message.success("Login successful!");

      // Navigate to home page after successful login
      setTimeout(() => {
        navigate("/home", { replace: true });
      }, 500);

    } catch (error) {
      console.error("Login Error:", error);
      setIsLoading(false);
      message.error("An error occurred. Please try again.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-page-container">
      <div className="login-content">
        <div className="login-form-section">
          <div className="login-card">
            {/* Header */}
            <div className="login-header">
              <h2 className="welcome-title">Please Login to Proceed</h2>
            </div>

            {/* Form */}
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Email"
                  required
                />
              </div>

              <div className="form-group">
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="form-input password-input"
                    placeholder="Password"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? "Processing..." : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

